import { render, staticRenderFns } from "./ForgotResetPassword.vue?vue&type=template&id=e7563038&"
import script from "./ForgotResetPassword.vue?vue&type=script&lang=js&"
export * from "./ForgotResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports